import React from "react";
import { ExternalLink, ShoppingBag } from "lucide-react";

const STORM_BG = "https://images.unsplash.com/photo-1537210249814-b9a10a161ae4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxzZXZlcmUlMjB3ZWF0aGVyJTIwc3Rvcm0lMjBjbG91ZHN8ZW58MHx8fHwxNzgwNzE3ODEzfDA&ixlib=rb-4.1.0&q=85";
const SHOP_URL = "https://vortexghost.com";

export default function Shop() {
  return (
    <div className="grain relative min-h-[80vh] flex items-center" data-testid="shop-page">
      <img src={STORM_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]" />

      <div className="container-vg relative section-pad text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 border border-yellow-400/40 bg-yellow-400/5 mb-8">
          <ShoppingBag className="w-8 h-8 text-yellow-400" />
        </div>

        <div className="overline">Official Merch</div>
        <h1 className="font-heading text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4">
          Shop at <span className="text-yellow-400">vortexghost.com</span>
        </h1>
        <p className="text-zinc-400 mt-8 max-w-xl mx-auto text-lg leading-relaxed">
          All Vortex Ghost merchandise — apparel, patches, stickers, and prints — is available at our official storefront.
          Proceeds support research and field operations.
        </p>

        <a
          href={SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary mt-12 inline-flex"
          data-testid="shop-visit-btn"
        >
          Visit vortexghost.com <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
